export default "__VITE_ASSET__C4vmt$xY__"